export default __webpack_public_path__ + "static/media/logo-light.f3657441.svg";